import { useEffect, useState } from "react";

export function DebugPage() {
  const [payload, setPayload] = useState<unknown>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    fetch("/api/debug", { headers: { Accept: "application/json" } })
      .then(async (response) => {
        const data = (await response.json()) as { error?: string } | unknown;
        if (!response.ok && isErrorPayload(data)) throw new Error(data.error || "Debug endpoint is disabled");
        if (!response.ok) throw new Error("Debug endpoint is disabled");
        setPayload(data);
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : "Unable to load debug data"));
  }, []);

  return (
    <main className="page-shell">
      <header className="site-header">
        <div>
          <p className="eyebrow">Chozen Yogurt</p>
          <h1>Menu Debug</h1>
        </div>
      </header>
      {error ? <div className="state-panel state-panel--error">{error}</div> : null}
      <pre className="debug-json">{JSON.stringify(payload, null, 2)}</pre>
    </main>
  );
}

function isErrorPayload(data: unknown): data is { error?: string } {
  return typeof data === "object" && data !== null && "error" in data;
}
